export default "__VITE_PUBLIC_ASSET__aff1d042__"